import { ErpDiv } from './ErpHtml';
import React from 'react';

export interface ErpRowProps {
  gutters?: boolean;
  alignV?: 'start' | 'center' | 'end';
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const ErpRow: React.FC<ErpRowProps> = ({ gutters, alignV, children, className, style }) => {
  const baseGrid = 'grid min-w-0 grid-cols-12';
  const gapClass = gutters === false ? 'gap-0' : 'gap-4';
  const alignVClass = alignV ? `items-${alignV === 'start' ? 'start' : alignV === 'end' ? 'end' : 'center'}` : '';
  const classes = [baseGrid, gapClass, alignVClass, className].filter(Boolean).join(' ');

  return <ErpDiv className={classes} style={style}>{children}</ErpDiv>;
};
